import { useLanguage } from "client/contexts/LanguageProvider";
import { getChunks, getStringValue, getTags, processText } from "components/common/Translate/Translate";
import { decodeHashCharacters } from "./decodeHashCharacters";

export const translateFunc = (key: string, variables?: Record<any, any>): string => {
    const { t, files, i18n } = useLanguage();

    return decodeHashCharacters(getChunks(getStringValue(key, files, t, i18n)).map(({ withTag, content }) => processText(withTag, content, getTags(content), variables)).join(""));
};
